import React, { useState } from 'react';
import { Dialog } from '../../components/ui/Dialog';
import { Button } from '../../components/ui/Button';
import { BillingResult } from '../../types/billing';
type Props = {
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: (reason: string) => Promise<BillingResult>;
  onClose: () => void;
  onDone: (message?: string) => void;
};

/** Confirmation that requires a written reason — used for voids, reversals and status changes. */
export function ReasonDialog({
  title,
  description,
  confirmLabel,
  onConfirm,
  onClose,
  onDone
}: Props) {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async () => {
    if (!reason.trim()) return setError('Enter a reason. It is kept in the audit trail.');
    setBusy(true);
    setError('');
    const result = await onConfirm(reason.trim());
    setBusy(false);
    if (!result.ok) return setError(result.error ?? 'The action failed.');
    onDone(result.message);
  };
  return <Dialog title={title} subtitle={description} onClose={onClose} footer={<>{error && <p role="alert" className="mr-auto text-sm text-red-700" data-id="element-4223" data-mp="6596bs00uo7r">{error}</p>}<Button variant="outline" onClick={onClose} data-id="element-4224" data-mp="a62py96flguu">Cancel</Button><Button variant="danger" onClick={submit} isLoading={busy} data-id="element-4225" data-mp="a4hwynzrm5z3">{confirmLabel}</Button></>} data-id="element-4222" data-mp="16phnju1mybp">
      <label htmlFor="reason-text" className="text-sm font-medium text-slate-700" data-id="element-4226" data-mp="f679k82myrpa">Reason<span className="text-red-600" data-id="element-4227" data-mp="k37f8hvkpsfv"> *</span></label>
      <textarea id="reason-text" rows={3} value={reason} onChange={e => setReason(e.target.value)} className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500" data-id="element-4228" data-mp="p33jmi86nlvy" />
    </Dialog>;
}